var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscribe-home"},[_c('subscribe-message-home-page',{attrs:{"belongs":"h5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }